import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconLock, IconLockOpen } from '@tabler/icons-react';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import CusCheckbox from '../../material-ui/CusCheckbox';
import FlexContainer from '../../material-ui/adaptive/FlexContainer';
import ShowContainer from '../../material-ui/ShowContainer';
import CusTooltip from '../../material-ui/CusTooltip';
import BonusInfoTooltip from './bonusInfoTooltip';

export default function SubgroupSave({
  lockSetting,
  id,
  isNodeGroup,
  updateSubgroups,
  saveDisabled,
  changeLockSetting,
  changeSubgroup,
  showUpdate,
  showLockSetting,
  onSave
}) {
  const { t } = useTranslation();
  const { isLessTablet } = useBootstrapSize();

  return (
    <Stack display={'flex'} direction={'column'} gap={0.25} mt={2}>
      <Stack display={'flex'} direction={'row'} alignContent={'center'} justifyContent={'end'}>
        <Box px={2}>
          <BonusInfoTooltip id={id} isNodeGroup={isNodeGroup} />
        </Box>
      </Stack>
      <FlexContainer
        justifyContent={'space-between'}
        flexDirection={isLessTablet ? 'column' : 'row'}
        gap={1}>
        <ShowContainer condition={showLockSetting && changeLockSetting} plug={<Box></Box>}>
          <CusCheckbox
            prevIcon={lockSetting ? <IconLock /> : <IconLockOpen />}
            label="Lock updating this bonus' settings from the parent group."
            checked={lockSetting}
            onChange={changeLockSetting}
          />
        </ShowContainer>
        <Stack display={'flex'} flexDirection={'row'} justifyContent={'end'} gap={1}>
          <ShowContainer condition={showUpdate}>
            <Stack display={'flex'} alignItems={'center'} flexDirection={'row'} gap={0}>
              <CusCheckbox
                label="Copy to subgroups"
                checked={updateSubgroups}
                onChange={changeSubgroup}
              />

              <CusTooltip
                text={
                  "If a subgroup doesn't have the flag set to block updates from its parent group, the current bonus settings are copied to all lower subgroups. This bonus will therefore also be available to players in these subgroups."
                }
              />
            </Stack>
          </ShowContainer>
          <Button size="large" variant="contained" onClick={onSave} disabled={saveDisabled}>
            {t('Save')}
          </Button>
        </Stack>
      </FlexContainer>
    </Stack>
  );
}
